module.exports = [
  {
    identifier: "level-1-ski",
    title: "Skilehrer Level 1",
    discipline: "Ski Alpin",
    conditions: {
      score_0: 0.15,
      score_3: 0.6,
    },
  },
  {
    identifier: "level-2-ski",
    title: "Skilehrer Level 2",
    discipline: "Ski Alpin",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-3-ski",
    title: "Skilehrer Level 3",
    discipline: "Ski Alpin",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-1-snowboard",
    title: "Snowboardlehrer Level 1",
    discipline: "Snowboard",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-2-snowboard",
    title: "Snowboardlehrer Level 2",
    discipline: "Snowboard",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-3-snowboard",
    title: "Snowboardlehrer Level 3",
    discipline: "Snowboard",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-1-nordic",
    title: "Skilehrer Nordic Level 1",
    discipline: "Langlauf",
    conditions: {
      score_0: 0.15,
      score_3: 0.6,
    },
  },
  {
    identifier: "level-2-nordic",
    title: "Skilehrer Nordic Level 2",
    discipline: "Langlauf",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-3-nordic",
    title: "Skilehrer Nordic Level 3",
    discipline: "Langlauf",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
  {
    identifier: "level-1-telemark",
    title: "Skilehrer Telemark Level 1",
    discipline: "Telemark",
    conditions: {
      score_0: 0.15,
      score_3: 0.6,
    },
  },
  {
    identifier: "level-2-telemark",
    title: "Skilehrer Telemark Level 2",
    discipline: "Telemark",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
];
